import { render, staticRenderFns } from "./z-pagination.vue?vue&type=template&id=9851c82a"
import script from "./z-pagination.vue?vue&type=script&lang=js"
export * from "./z-pagination.vue?vue&type=script&lang=js"
import style0 from "./z-pagination.vue?vue&type=style&index=0&id=9851c82a&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9851c82a')) {
      api.createRecord('9851c82a', component.options)
    } else {
      api.reload('9851c82a', component.options)
    }
    module.hot.accept("./z-pagination.vue?vue&type=template&id=9851c82a", function () {
      api.rerender('9851c82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/z-pagination.vue"
export default component.exports